<template>
<e-chart ref="chart" />
</template>

<script>
const DIRECTIONS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW']
const ANGLE_STEP = 360 / DIRECTIONS.length
const HALF_ANGLE = ANGLE_STEP / 2

const AQI_LEVELS = [{
  value: 50,
  color: 'rgb(0, 228, 0)',
  label: '优'
}, {
  value: 100,
  color: 'rgb(255, 225, 0)',
  label: '良'
}, {
  value: 150,
  color: 'rgb(155, 165, 0)',
  label: '轻度污染'
}, {
  value: 200,
  color: 'rgb(255, 0, 0)',
  label: '中度污染'
}, {
  value: 300,
  color: 'rgb(65, 20, 69)',
  label: '重度污染'
}, {
  value: 2147483647,
  color: 'rgb(126, 0, 35)',
  label: '严重污染'
}]

export default {
  name: 'WindRoseChart',
  props: {
    factor: {
      required: true,
      type: Object
    },
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render () {
      let {factor, data: {data}} = this
      let factorId = factor.id
      let directionsLen = DIRECTIONS.length
      let dataMap = data.filter(data => Number.isFinite(data['1013'])).reduce((map, data) => {
        let value = data[`${factorId}Iaqi`]

        if (!Number.isFinite(value)) {
          return map
        }

        let index = AQI_LEVELS.findIndex(aqiLevel => value <= aqiLevel.value)
        let dataList = map[index]

        let angle = data['1013']
        let angleIndex = Math.floor(((angle + HALF_ANGLE) % 360) / ANGLE_STEP)
        dataList[angleIndex] += 1

        return map
      }, AQI_LEVELS.reduce((map, aqiLevel, index) => {
        map[index] = new Array(directionsLen).fill(0)
        return map
      }, {}))

      let chartOpt = {
        title: {
          text: `${factor.name}`,
          textStyle: {
            fontSize: 14
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          // trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          right: 0,
          bottom: 0,
          orient: 'vertical'
        },
        angleAxis: {
          type: 'category',
          data: DIRECTIONS
        },
        radiusAxis: {
        },
        polar: {
        },
        series: AQI_LEVELS.map((aqiLevel, index) => ({
          name: aqiLevel.label,
          type: 'bar',
          coordinateSystem: 'polar',
          stack: 'WindRose',
          data: dataMap[index],
          color: aqiLevel.color
        }))
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/WindRoseChart.vue